
module.exports = ['$resource', function ( $resource ) {

    let FieldTypes = $resource('/fieldtypes/',
        {},
        { 
        	'get': {method:'GET'} 
    	}
    );

    return FieldTypes;
}];